import type { CSSProperties } from "react";
import { Link } from "react-router-dom";

type BrandLogoVariant = "full" | "wordmark" | "icon";
type BrandLogoTone = "light" | "dark";

type BrandLogoProps = {
  className?: string;
  height?: number;
  style?: CSSProperties;
  to?: string;
  tone?: BrandLogoTone;
  variant?: BrandLogoVariant;
};

const logoMarkSrc = "/branding/r5-claw-grip.svg";

export function BrandLogo({
  className,
  height = 36,
  style,
  to,
  tone = "dark",
  variant = "full",
}: BrandLogoProps) {
  const textColor = tone === "dark" ? "#f0f1f4" : "#1a1a2e";
  const textSize = Math.max(13, Math.round(height * 0.48));
  const gap = Math.max(7, Math.round(height * 0.22));

  const image = (
    <span
      style={{
        alignItems: "center",
        display: "inline-flex",
        gap: variant === "wordmark" ? Math.round(gap * 0.75) : gap,
        minWidth: 0,
        ...style,
      }}
    >
      <img
        src={logoMarkSrc}
        alt=""
        aria-hidden="true"
        style={{ display: "block", height, width: height }}
      />
      {variant !== "icon" && (
        <span
          style={{
            color: textColor,
            display: "inline-flex",
            fontSize: textSize,
            fontWeight: 700,
            letterSpacing: 0,
            lineHeight: 1,
            whiteSpace: "nowrap",
          }}
        >
          <span style={{ color: "#EA580C" }}>OpenClaw</span>
          <span style={{ color: "#2DD4BF" }}>Machines</span>
        </span>
      )}
    </span>
  );

  if (!to) return image;

  return (
    <Link to={to} className={className} aria-label="OpenClaw Machines">
      {image}
    </Link>
  );
}
